module.exports = __webpack_public_path__ + "img/2011.2b4fd857.jpg";